import type { FaireProductEntity } from "../../entity_types/product";

export const p_att9f2he6e: FaireProductEntity = {
  token: "p_att9f2he6e",
  type: "product",
  name: "Crystal Moon Suncatcher – Gemstone Hanging Wall & Window Décor for Light & Energy",
  brandToken: "b_9aggj4kudk",
  brandName: "Earth's Gems BTQ",
  imageUrl:
    "https://cdn.faire.com/fastly/48f4dea72cc84b648dfabb0828e9bdd4328f5763067a8439ff70d92f99a73ed7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dccd4c261828f76363830c80d136578dbf31e5a93fb4806204961f15cea03f9c.jpeg",
    "https://cdn.faire.com/fastly/b3058f4b492d2b44c3c2665d2784736a65cecae664b62d55e0162d1bde53e74c.jpeg",
    "https://cdn.faire.com/fastly/00d9df71b7a5d42e95b686e471d18b77f259c2d46f43feec7d75e9120309f06f.jpeg",
    "https://cdn.faire.com/fastly/e128c37c8a6e3e2b37b90329bfb46db6dd10783d47b11c7c78f829a28ec3dce4.jpeg",
    "https://cdn.faire.com/fastly/f3eed8bae88f7626bc5e48b04e0498a20e76dc5cfc446e71e4aa5f32b29dc275.jpeg",
    "https://cdn.faire.com/fastly/8cc4e8637b24dae6f7983cb8e7bc4595a3ec699adf0827cacff47c73f83102fb.jpeg",
    "https://cdn.faire.com/fastly/56b52121b8dd60535b067ffdf9aa514013f522e90ba02c7559fd134f8802caeb.jpeg",
    "https://cdn.faire.com/fastly/25163549d29e41cb81bf0edd006b3edc599228d79a3b440a7cc90cfb24f4f0c0.jpeg",
    "https://cdn.faire.com/fastly/5c11da6dbb26229ae0a9bfdc4a569c843c8eabd57f631a59d56b0948a729600a.jpeg",
    "https://cdn.faire.com/fastly/d1fe3bccc965bc16297a397756ae259c7d36d4ec517da02c152947bdf845d007.jpeg",
    "https://cdn.faire.com/fastly/87f7fa5e771f6e808163b10b4c13081ef2b1ea33e7a264849c3c88215223a778.jpeg",
  ],
  priceDollars: 14,
  description:
    "✨ Bring balance, beauty, and calming energy into your home with our Oval Crystal Zen Garden Night Lamp. Handcrafted with genuine crystals arranged inside a glowing oval frame, this lamp transforms any space into a sanctuary of peace.\n\n🌙 Why You’ll Love It:\n\n * \nAuthentic Crystals: Each lamp is filled with natural gemstones such as clear quartz, amethyst, aventurine, and more — chosen for their unique energy and beauty.\n\n * \nSoothing LED Glow: The warm light creates a tranquil atmosphere, perfect for meditation, relaxation, or bedtime rituals.\n\n * \nMindful Design: The oval frame and crystal garden aesthetic bring grounding harmony to your home décor.\n\n * \nVersatile Use: Ideal for bedrooms, living rooms, meditation spaces, or as a thoughtful gift.\n\n✨ Details:\n\n * \nOval-shaped LED lamp with embedded crystals & greenery accents\n\n * \nHeight: approx. 8–10 in. (varies slightly due to handcrafted nature)\n\n * \nPower: USB connection (with on/off switch)\n\n * \nEnergy-efficient warm LED lighting\n\n * \nCrystals may include: Clear Quartz, Amethyst, Aventurine, Citrine, Obsidian, and others\n",
  tags: [],
  msrpDollars: 28,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:37.413Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
